import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/community/_components/CommunityContent.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")